module.exports = __webpack_public_path__ + "img/13.aa4c5f7.png";